import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import SendIcon from "@material-ui/icons/Send";

import { firestore } from "../../../firebase/firebasejs";
import { fechahoraNew } from "../../../services/utils";
import { showSnackbar } from "../../../data-store/actions/organizers-actions";
import tarjetaContacto from "../../../assets/brand/tarjeta-contacto.jpg";

const WHATSAPP_URL = "https://wa.me/522205747108";

// Formulario oculto temporalmente hasta definir el proceso de notificación
// de cada registro nuevo en "landingMails". Reactivar cambiando esto a true.
const MOSTRAR_FORMULARIO = false;

const useStyles = makeStyles((theme) => ({
  section: {
    backgroundColor: "#ffebee",
    marginTop: theme.spacing(6),
    padding: theme.spacing(5, 2),
  },
  heading: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  formPaper: {
    padding: theme.spacing(3),
    height: "100%",
  },
  field: {
    marginBottom: theme.spacing(2),
  },
  cardLink: {
    display: "flex",
    height: "100%",
    backgroundColor: "#fff",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
  },
  cardImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    transition: theme.transitions.create("transform"),
    "&:hover": {
      transform: "scale(1.02)",
    },
  },
}));

const initialForm = { email: "", phoneNumber: "", comment: "" };

const ContactSection = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [form, setForm] = useState(initialForm);
  const [enviando, setEnviando] = useState(false);

  const handleChange = (campo) => (event) => {
    setForm({ ...form, [campo]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setEnviando(true);

    firestore
      .collection("landingMails")
      .add({
        email: form.email,
        phoneNumber: form.phoneNumber,
        comment: form.comment,
        date: fechahoraNew(),
      })
      .then(() => {
        dispatch(
          showSnackbar(
            true,
            "Gracias por suministrar tus datos, pronto nos pondremos en contacto.",
            4000
          )
        );
        setForm(initialForm);
      })
      .catch(() => {
        dispatch(showSnackbar(true, "Ocurrió un error, intenta de nuevo.", 4000));
      })
      .finally(() => setEnviando(false));
  };

  return (
    <div className={classes.section}>
      <Typography variant="h4" component="h2" className={classes.heading}>
        Contáctanos para más información
      </Typography>
      <Grid
        container
        spacing={3}
        justifyContent={MOSTRAR_FORMULARIO ? "flex-start" : "center"}
      >
        {MOSTRAR_FORMULARIO && (
          <Grid item xs={12} md={6}>
            <Paper elevation={1} className={classes.formPaper}>
              <Typography variant="h6" gutterBottom>
                Déjanos tu correo electrónico o número telefónico
              </Typography>
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Email"
                  type="email"
                  required
                  className={classes.field}
                  value={form.email}
                  onChange={handleChange("email")}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Número telefónico"
                  className={classes.field}
                  value={form.phoneNumber}
                  onChange={handleChange("phoneNumber")}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Comentario"
                  multiline
                  minRows={3}
                  className={classes.field}
                  value={form.comment}
                  onChange={handleChange("comment")}
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  endIcon={<SendIcon />}
                  disabled={enviando}
                >
                  Enviar
                </Button>
              </form>
            </Paper>
          </Grid>
        )}
        <Grid item xs={12} sm={8} md={MOSTRAR_FORMULARIO ? 6 : 5}>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            className={classes.cardLink}
          >
            <img
              src={tarjetaContacto}
              alt="Contacto Dashport — clic para escribirnos por WhatsApp"
              className={classes.cardImage}
            />
          </a>
        </Grid>
      </Grid>
    </div>
  );
};

export default ContactSection;
